<template>
  <div class="dataAnalysis">
    <div class="search-box">
      <el-form inline :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <TabBar :list="tabList" v-model="searchForm.type" @change="getList"/>
        </el-form-item>
        <el-form-item v-if="searchForm.type === '1'">
          <el-select
            class="form-select"
            popper-class="form-select-dropdown"
            :popper-append-to-body="false"
            v-model="searchForm.town"
            @change="getList"
            placeholder="请选择">
            <el-option
              v-for="item in townshipList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            clearable
            class="form-time-select"
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
            popper-class="form-time-select-dropdown form-time-picker-dropdown"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <TableBox class="table-box" id="table-box">
      <el-table
        v-if="refresh"
        :height="height"
        :data="tableData" class="fireTable" stripe>
        <el-table-column
          v-for="(item, i) in tableColumn"
          :key="i"
          :prop="item.prop"
          align="center"
          :min-width="item.width"
          :label="item.label">
          <template slot-scope="scope">
            <span v-if="item.prop === 'date'">
               {{ scope.row[item.prop] }}时
            </span>
            <div v-else>
              <div class="progress-box">
                <div class="progress" v-if="scope.row[item.prop] > 0" :style="{ width: (scope.row[item.prop] / max) * 100 +'%'}"></div>
              </div>
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </TableBox>
  </div>
</template>

<script>
import TabBar from "../../RealTimeScheduling/DataScreen/common/TabBar";
import { townshipList } from "../../../utils/common";
import TableBox from '@/components/ClipBox/index.vue'
import { getDataAnalysisTownData, getDataAnalysisPointData } from "../../../api/dataCenter";
import dayjs from 'dayjs';
export default {
  name: "index",
  components: { TabBar, TableBox },
  data () {
    return {
      townshipList,
      date: null,
      searchForm: {
        type: '0',
        town: '001',
        startTime: '',
        endTime: ''
      },
      height: 500,
      tabList: [
        { label: "乡镇统计", value: "0" },
        { label: "点位统计", value: "1" }
      ],
      responseList: [],
      tableData: [{},{},{},{},{},{},{},{},{},{},{},{},{}],
      tableColumn: [
        { label: '时间', prop: 'date', width: 100 }
      ],
      max: 0,
      refresh: true
    }
  },
  mounted() {
    this.date = [this.getDay(-7), dayjs(`${new Date()}`).format('YYYY-MM-DD')]
    this.searchForm.startTime = this.getDay(-7)
    this.searchForm.endTime = dayjs(`${new Date()}`).format('YYYY-MM-DD')
    this.height = document.getElementById('table-box').offsetHeight
    this.getList()
  },
  methods: {
    getList () {
      if (this.searchForm.type === '0') {
       this.getDataAnalysisTownData()
      } else if (this.searchForm.type === '1') {
        this.getDataAnalysisPointData()
      }
    },
    getDataAnalysisTownData () {
      this.refresh = false
      getDataAnalysisTownData(this.searchForm).then(res => {
        this.getColumnData(res.data)
        this.refresh = true
      })
    },
    getDataAnalysisPointData () {
      this.refresh = false
      getDataAnalysisPointData(this.searchForm).then(res => {
        this.getColumnData(res.data)
        this.refresh = true
      })
    },
    getColumnData (responseList) {
      this.max = 0
      this.responseList = responseList
      this.tableData = []
      for(let i = 0; i < 24; i++) {
        if (i <= 9) {
          this.tableData.push({date: '0' + i})
        } else {
          this.tableData.push({date: i.toString()})
        }
      }
      this.tableColumn = [{ label: '时间', prop: 'date', width: 100 }]
      this.responseList.forEach(item => {
        this.tableColumn.push({label: item.fieldName, prop: item.fieldId, width: 150})
        this.tableData.forEach(row => {
          row[item.fieldId] = 0
        })
      })
      this.tableData.forEach((item) => {
        this.responseList.forEach(row => {
          row.hourData.forEach(data => {
            if (data.hour === item.date) {
              item[row.fieldId] = data.count
              if (data.count > this.max) this.max = data.count
            }
          })
        })
      })

    },
    changeDate (date) {
      if (date === null) {
        this.searchForm.startTime = null
        this.searchForm.endTime = null
      } else {
        if (date[0] === date[1]) {
          this.searchForm.startTime = date[0] + ' 00:00:00'
          this.searchForm.endTime = date[1] + ' 23:59:59'
        } else {
          this.searchForm.startTime = date[0]
          this.searchForm.endTime = date[1]
        }

      }
      this.getList()
    },
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month){
      var m = month;
      if(month.toString().length == 1){
        m = "0" + month;
      }return m;
    }
  }
}
</script>

<style scoped lang="less">
  .dataAnalysis{
    height: 100%;
    .search-box{
      padding-top: 15px;
      .form-select{
        /deep/ .el-input__inner{
          height: 40px;
        }
      }
      /deep/ .el-form-item{
        margin-bottom: 10px;
      }
    }
    .table-box{
      width: 1550px;
      height: calc(100% - 90px);
    }
    /deep/ .tab-bar{
      height: 41px;
      .tab-txt{
        font-size: 16px;
      }
      .tab-item{
        padding: 2px 20px;
      }
    }
  }
  /deep/.el-table, /deep/.el-table__expanded-cell{
    background-color: rgba(255, 255, 255, 0) !important;
  }
  /deep/ th,.el-table__cell{
    font-weight: 500;
    background-color: #00606E !important;
    border-bottom: 0 !important;
    font-size: 20px;
    color: #FFFFFF;
    padding: 0;
  }
  /deep/ td,.el-table__cell{
    color: #FFFFFF;
    border-bottom: 0 !important;
    background-color: rgba(0, 51, 71, 0) !important;
  }
  /deep/ .el-table tr{
    background-color: rgba(255, 255, 255, 0);
  }
  /deep/.el-table__row--striped{
    td{
      background: rgba(0, 255, 246, 0.1) !important;
    }
  }
  /deep/ .el-table__body-wrapper{
    &::-webkit-scrollbar-corner {
      background: rgba(0,0,0) !important;
    }
    &::-webkit-scrollbar{
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgb(16, 81, 131);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
      background: linear-gradient(90deg,#201c29,#201c29 1px,#100e17 0,#100e17);
    }
  }
  .progress-box{
    display: inline-block;
    width: 103px;
    height: 21px;
    text-align: left;
    .progress{
      height: 21px;
      background: linear-gradient(87deg, #FDB62C 0%, #FFEB86 100%);
    }
  }

</style>
